import FormLabel from '@rio-cloud/rio-uikit/FormLabel';
import { useId } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { TextInput } from '../../../../sharedComponents/sidebar/TextInput';
import { MeansOfTransport } from '../../../transportAssignment.types';
import { ValidatedFormGroup } from '../ValidatedFormGroup';

import { ValidationResult } from '../../../../sharedComponents/validationResult.type';

type TrailerFormInputProps = {
    meansOfTransport: MeansOfTransport | undefined;
    setTrailerId: (value: string | undefined) => void;
    validation: ValidationResult;
    isFormDisabled: boolean;
};
export const TrailerFormInput = ({
    meansOfTransport,
    setTrailerId,
    validation,
    isFormDisabled,
}: TrailerFormInputProps) => {
    const inputId = useId();
    const intl = useIntl();

    const supportingText = intl.formatMessage({
        id: 'outboundOrderBook.transportAssignments.sidebar.confirmationForm.trailerId.info',
    });

    return (
        <div className="width-50pct padding-left-5">
            <FormLabel htmlFor={inputId} supportingText={supportingText} className="flex-column ellipsis-1">
                <FormattedMessage id="outboundOrderBook.transportAssignments.sidebar.confirmationForm.trailerId" />
            </FormLabel>
            <ValidatedFormGroup validation={validation}>
                <TextInput
                    id={inputId}
                    placeholder={intl.formatMessage({
                        id: 'outboundOrderBook.transportAssignments.sidebar.confirmationForm.trailerId.placeholder',
                    })}
                    value={meansOfTransport?.trailerId ?? ''}
                    setValue={setTrailerId}
                    disabled={isFormDisabled}
                />
            </ValidatedFormGroup>
        </div>
    );
};
